import React, { useEffect } from 'react';
import { User } from '@/types';
import M_CapsuleCard from '@/components/M_Molecules/M_CapsuleCard/M_CapsuleCard';
import { W_MasonryGrid } from '@/components/W_Wrappers/W_MasonryGrid/W_MasonryGrid';
import W_CapsulesEmptyState from '@/components/W_Wrappers/W_CapsulesEmptyState/W_CapsulesEmptyState';

interface FeedPageProps {
  user: User;
  onLogout: () => void;
  cards: Array<{
    id: string;
    title: string;
    image?: string;
    avatars: string[];
    coauthors: number;
    commentsCount?: number;
    isMyCapsule: boolean;
    ownerName: string;
    ownerId: string;
    isAdminCapsule?: boolean;
  }>;
  loadMore: () => void;
}

export const FeedPage: React.FC<FeedPageProps> = ({ cards, loadMore }) => {
  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
        document.documentElement.scrollHeight - 1000
      ) {
        loadMore();
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [loadMore]);

  return (
    <>
      <W_MasonryGrid>
        {cards.map(post => (
          <M_CapsuleCard
            key={post.id}
            id={post.id}
            image={post.image || undefined}
            title={post.title}
            avatars={post.avatars}
            coauthors={post.coauthors}
            commentsCount={post.commentsCount}
            isMyCapsule={post.isMyCapsule}
            ownerName={post.ownerName}
            ownerId={post.ownerId}
            isAdminCapsule={post.isAdminCapsule}
          />
        ))}
      </W_MasonryGrid>
      {cards.length === 0 && (
        <W_CapsulesEmptyState translationKey='feed.emptyCapsules' hasButton />
      )}
    </>
  );
};
